import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";

import { fetchWrapper } from "_helpers";

// create slice

const name = "poheaders";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  extraReducers,
  reducers: {
    filterSelection(state, action) {
      state.selectedFilterList = action.payload;
    },
    resetData(state) {
      state.list.value.data = { currentPage: 0, rows: [], totalItems: 0, totalPages: 0, type: '' }
    },
  },
});

// exports

export const poheadersActions = { ...slice.actions, ...extraActions };
export const poheadersReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    list: {
      loading: true,
      value: {
        data: { currentPage: 0, rows: [], totalItems: 0, totalPages: 0, type: '' },
      },
    },
    filters: { loading: true },
    item: { loading: true },
    action: { loading: true },
    selectedFilterList: {},
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;

  return {
    getAll: getAll(),
    getScheduleList: getScheduleList(),
    updateSchedule: updateSchedule(),
    getById: getById(),
    getFilters: getFilters(),
    getAllFilter: getAllFilter(),
    getAsnList: getAsnList(),
    confirmPo: confirmPo(),
  };
 // type:  'new' | 'confirm' | 'cancelled'
  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async ({ page, pageSize, scheduledList = true, type = 'all' }) => {
        const listTypeParam = type !== 'all' ? `&list_type=${type}` : '';
        const scheduledListParam = !scheduledList  ? `&scheduledList=false` : '';
        const url = `${baseUrl}/po/getall?page=${page}&size=${pageSize}${listTypeParam}${scheduledListParam}`;
  
        return await fetchWrapper.get(url)
    });
  }
  function getScheduleList() {
    return createAsyncThunk(
      `${name}/schedule/`,
      async ({ page, pageSize, type ='review' }) => // pending, review
        await fetchWrapper.get(
          `${baseUrl}/schedule/pohScheduleheaderList?page=${page}&size=${pageSize}${type ? `&list_type=${type}` : ''}`
        )
    );
  }
  function updateSchedule() {
    return createAsyncThunk(
      `${name}/updateSchedule`,
      async (payload, { rejectWithValue }) => {
        try {
          const response = await fetchWrapper.put(`${baseUrl}/schedule/updateDeliverySchedule`, payload);
          return response.data;
        } catch (error) {
        
          return rejectWithValue(error);
        }
      }
    );
  }
  function getAsnList() {
    return createAsyncThunk(
      `${name}/asn/`,
      async ({ page, pageSize }) =>
        await fetchWrapper.get(
          `${baseUrl}/asn/pohasnHeading?page=${page}&limit=${pageSize}`
        )
    );
  }
  function getById() {
    return createAsyncThunk(
      `${name}/getById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/po/${id}`)
    );
  }

  function getAllFilter() {
    return createAsyncThunk(
      `${name}/getAllFilter`,
      async ({ page, pageSize, url }) =>
        await fetchWrapper.get(
          `${baseUrl}/po/getall?page=${page}&size=${pageSize}${url}`
        )
    );
  }

  function getFilters() {
    return createAsyncThunk(
      `${name}/getFilters`,
      async () => await fetchWrapper.get(`${baseUrl}/po/filters`)
    );
  }

  // Define the confirmPo action
  function confirmPo() {
    return createAsyncThunk(
      `${name}/confirmPo`,
      async (poNumbers, { rejectWithValue }) => {
        try {
          const response = await fetchWrapper.put(`${baseUrl}/po/confirm-new-order`, {
            poNumbers,
          });
          return response.data;
        } catch (error) {
        
          return rejectWithValue(error);
        }
      }
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    getAll();
    getScheduleList();
    updateSchedule();
    getById();
    getFilters();
    getAllFilter();
    getAsnList();
    confirmPo();
    function getAll() {
      var { pending, fulfilled, rejected } = extraActions.getAll;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(fulfilled, (state, action) => { console.log('action.payload', action.meta.arg.type, current(state).list.value?.data?.type  )
         
          const type = action.meta.arg.type;
          const reload = action.meta.arg.reload;
          const existingType = current(state).list.value?.data?.type;
          let exitstingRows = type === existingType ? current(state).list.value?.data?.rows : [];
          if (reload) {
            exitstingRows = [];
          }
          state.list = {
            value: {
              data: {
                currentPage: action.payload?.data?.currentPage,
                rows: [...exitstingRows, ...(action.payload?.data?.rows ?? [])],
                totalItems: action.payload?.data?.totalItems,
                totalPages: action.payload?.data?.totalPages,
                type: action.meta.arg.type,
              },
            },
          };
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.list = { error: action.error };
        });
    }
    function getScheduleList() {
      var { pending, fulfilled, rejected } = extraActions.getScheduleList;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          const type = action.meta.arg.type;
          const existingType = current(state).list.value?.data?.type;
          let exitstingRows = type === existingType && action.meta.arg.page !== 0 ? current(state).list.value?.data?.rows : [];
    
          state.list = {
            value: {
              data: {
                currentPage: action.payload.data.currentPage,
                rows: [...exitstingRows, ...(action.payload.data?.rows || [])],
                totalItems: action.payload.data.totalItems,
                totalPages: action.payload.data.totalPages,
                type: action.meta.arg.type,
              },
            },
          };
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.list = { error: action.error };
        });
    }
    function getAsnList() {
      var { pending, fulfilled, rejected } = extraActions.getAsnList;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          const exitstingRows = current(state).list.value.data.rows;
          state.list = {
            value: {
              data: {
                currentPage: action.payload.data.currentPage,
                rows: [...exitstingRows, ...(action.payload.data?.rows || [])],
                totalItems: action.payload.data.totalItems,
                totalPages: action.payload.data.totalPages,
              },
            },
          };
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.list = { error: action.error };
        });
    }
    function getById() {
      var { pending, fulfilled, rejected } = extraActions.getById;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
          state.action = { loading: false };
        })
        .addCase(fulfilled, (state, action) => {
          state.item = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.item = { error: action.error };
        });
    }
    function getAllFilter() {
      var { pending, fulfilled, rejected } = extraActions.getAllFilter;
      builder
        .addCase(pending, (state) => {
          state.item = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.list = {
            value: {
              data: {
                currentPage: action.payload.data?.currentPage,
                rows: action.payload.data ? [...(action.payload.data.rows ?? [])] : [],
                totalItems: action.payload.data?.totalItems,
                totalPages: action.payload.data?.totalPages,
              },
            },
          };
          state.item = { loading: false };
        })
        .addCase(rejected, (state, action) => {
          state.list = { error: action.error };
        });
    }
    function getFilters() {
      var { pending, fulfilled, rejected } = extraActions.getFilters;
      builder
        .addCase(pending, (state) => {
          state.filters = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.filters = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.filters = { error: action.error };
        });
    }
    function confirmPo() {
      var { pending, fulfilled, rejected } = extraActions.confirmPo;
   
      builder
        .addCase(pending, (state) => {
          state.action = { loading: true };
        })
        .addCase(fulfilled, (state) => {
          state.action = { loading: false, status: 'success' };
        })
        .addCase(rejected, (state, action) => {   
          state.action = {loading: false, error: action.payload };
        });
    }
    function updateSchedule() {
      var { pending, fulfilled, rejected } = extraActions.updateSchedule;
   
      builder
        .addCase(pending, (state) => {
          state.action = { loading: true };
        })
        .addCase(fulfilled, (state) => {
          state.action = { loading: false, status: 'success' };
        })
        .addCase(rejected, (state, action) => {   
          state.action = {loading: false, error: action.payload };
        });
    }
  };
}
